'use client'

import { useEffect } from 'react'
import { useUser } from '@clerk/nextjs'
import * as Sentry from '@sentry/nextjs'

export function SentryUserContext() {
  const { isLoaded, isSignedIn, user } = useUser()

  useEffect(() => {
    if (!isLoaded) return
    if (isSignedIn && user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        username: user.username ?? undefined
      })
    } else {
      Sentry.setUser(null)
    }
  }, [isLoaded, isSignedIn, user])

  return null
}
